import { ZodError } from 'zod'

import { showNotificationErrorFx } from '../providers'

export const notifyMaxLengthExceeded = (error: unknown) => {
  if (error instanceof ZodError && error.errors[0].code === 'too_big') {
    void showNotificationErrorFx({
      message: `Название трека не должно превышать ${error.errors[0].maximum} символов`,
    })
    return true
  }
  return false
}
